import axios from "axios";
import Cookies from "js-cookie";
import { FIRMFLOWURL } from "../url";

const request = async (path, config) => {
    try {
        const token = Cookies.get("Bearer");
        const response = await axios.get(`${FIRMFLOWURL}${path}`, {
            ...config,
            headers: { Authorization: token },
        });
        return { ...response, success: true };
    } catch (error) {
        if (error?.response?.status === 401) {
            Cookies.remove("Bearer");
            window.location.replace("/");
            return { success: false, status: 401 };
        }
        return {
            success: false,
            status: error?.response?.status,
            data: error?.response?.data,
            message:
                error?.response?.data?.message ||
                error?.message ||
                "The client review queue could not be loaded.",
        };
    }
};

export const getAnnualClientActivityReviewQueueCount = () =>
    request("api/Client/review-queue/count");

export const getAnnualClientActivityReviewQueue = ({ page = 1, pageSize = 50 } = {}) =>
    request("api/Client/review-queue", { params: { page, pageSize } });
